export default "__VITE_ASSET__BmIz_DVf__"